import type { ModalSolicitudEnviadaProps } from "../../core/types/tsx/components/modals/ModalSolicitudEnviada.types";
import { CheckCircle2, X } from "lucide-react";

export function ModalSolicitudEnviada({
	open,
	onClose,
	title = "Solicitud enviada",
	message = "Hemos enviado tu pedido al proveedor, por favor espera un momento su respuesta.",
}: ModalSolicitudEnviadaProps) {
	if (!open) return null;

	return (
		<div
			className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4'
			onClick={onClose}
		>
			<div
				className='relative w-full max-w-sm rounded-2xl bg-white px-6 py-5 soft-border card-shadow'
				onClick={(e) => e.stopPropagation()}
			>
				<button
					type='button'
					onClick={onClose}
					aria-label='Cerrar'
					className='absolute right-4 top-4 rounded-full p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700 cursor-pointer'
				>
					<X className='h-4 w-4' />
				</button>

				<div className='flex items-center gap-3'>
					<div className='relative'>
						<span className='absolute inset-0 rounded-full bg-primary/20 animate-ping' />
						<span className='relative inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary'>
							<CheckCircle2 className='h-5 w-5' />
						</span>
					</div>
					<div>
						<h2 className='text-base font-semibold text-slate-900'>
							{title}
						</h2>
						<p className='mt-1 text-xs text-slate-500'>{message}</p>
					</div>
				</div>

				<div className='mt-5 rounded-xl bg-secondary px-4 py-3'>
					<p className='text-xs text-primary'>
						Puedes revisar el estado en la sección de pedidos.
					</p>
				</div>

				<button
					type='button'
					onClick={onClose}
					className='mt-5 w-full rounded-full bg-primary px-4 py-2 text-xs font-semibold text-white transition hover:bg-primary-hover cursor-pointer'
				>
					Entendido
				</button>
			</div>
		</div>
	);
}
